import { render, staticRenderFns } from "./index.vue?vue&type=template&id=350e6cee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=350e6cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350e6cee",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CHeading: require('@chakra-ui/vue').CHeading, CFlex: require('@chakra-ui/vue').CFlex, CImage: require('@chakra-ui/vue').CImage, CInput: require('@chakra-ui/vue').CInput, CFormControl: require('@chakra-ui/vue').CFormControl, CText: require('@chakra-ui/vue').CText, CButton: require('@chakra-ui/vue').CButton, CIcon: require('@chakra-ui/vue').CIcon, CBox: require('@chakra-ui/vue').CBox, CListItem: require('@chakra-ui/vue').CListItem, CList: require('@chakra-ui/vue').CList})
